import { BmDataFillingType } from "./bm-enums";
import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const DEFAULTS = {
  YEARS_NUMBER: 10,
  TOTAL_COMMITMENT: 100e6,
  COMMITMENT: 50e6,
  MGM_FEE_PCNT: 2,
  PCNT_MGM_FEE: 100,
  VAT: 18,
  INVESTMENT: 20e6,
};


export type MgmFeeKey =
  | 'commitment'
  | 'mgmFeesPcnt'
  | 'pcntOfMgmFees'
  | 'vatPcnt'
  | 'mgmFeeValues'
  | 'vatValues'
  | 'catchUp';

export const MG_FEE_SUBGROUPS: ReadonlyArray<{ key: MgmFeeKey; std: number; isSelected?: boolean; }> = [
  { key: 'commitment', std: DEFAULTS.COMMITMENT },
  { key: 'mgmFeesPcnt', std: DEFAULTS.MGM_FEE_PCNT },
  { key: 'pcntOfMgmFees', std: DEFAULTS.PCNT_MGM_FEE, isSelected: true },
  { key: 'vatPcnt', std: DEFAULTS.VAT, isSelected: true },
  { key: 'mgmFeeValues', std: 0 },
  { key: 'vatValues', std: 0 },
  { key: 'catchUp', std: 0, isSelected: false },
];

export const DEFAULT_OP_EXPENSES: ReadonlyArray<[string, number, BmDataFillingType]> = [
  ['Fund administration', 150_000, BmDataFillingType.YEARLY],
  ['Audit', 25_000, BmDataFillingType.YEARLY],
  ['K-1 reporting', 10_000, BmDataFillingType.YEARLY],
  ['Other', 0, BmDataFillingType.MANUAL],
];

export const DEFAULT_ORG_EXPENSES: ReadonlyArray<[string, number, BmDataFillingType]> = [
  ['Org./liquidation fees', 0, BmDataFillingType.MANUAL],
  ['Fundraising', 0, BmDataFillingType.MANUAL],
];

/**
 * Conversion map for *standard* values according to the exp group **data‑filling type**.
 *
 * Each tuple contains two pure functions:
 *  first => quarterFn – derives a *single‑quarter* value from the standard value.
 *  second => yearFn   – derives the *year* value from the standard value.

 */
export const DATA_FILLING_TYPE_CONVERTERS: Record<BmDataFillingType, [(v: number) => number, (v: number) => number]> = {
  [BmDataFillingType.YEARLY]: [
    (v): number => v / 4, // spread yearly value equally across 4 quarters
    (v): number => v, // yearly value stays the same
  ],
  [BmDataFillingType.QUARTERLY]: [
    (v): number => v, // quarter value is already the standard value
    (v): number => v * 4, // four identical quarters make the year
  ],
  [BmDataFillingType.MONTHLY]: [
    (v): number => v * 3, // 3× monthly value per quarter
    (v): number => v * 12, // 12× monthly value per year
  ],
  [BmDataFillingType.MANUAL]: [
    (): number => 0, // no auto‑fill for manual mode (quarter)
    (): number => 0, // no auto‑fill for manual mode (year)
  ],
} as const;

export const MAX_MODEL_YEARS_NUMBER = 20;
export const DEFAULT_ITEMS_NUMBER_IN_YEAR = 5;


export const ValidatorMustStayDisabled: ValidatorFn = (control: AbstractControl): ValidationErrors | null => (control.enabled ? { mustStayDisabled: true } : null);
export const ValidatorNotBlank: ValidatorFn = (control: AbstractControl): ValidationErrors | null => (control.value && control.value.trim().length === 0 ? { whitespace: true } : null);
